export const TASK_ERROR_CODES = {
    1: "There was an issue classifying this document.",
    2: "There was an issue classifying this document.",
    3: "There was an issue extracting results from this document.",
    4: "Upload of this document failed."
}